define('sdk/api',['utils/constants', 'utils/wrapper', 'runtime', 'easyXDM/easyXDM', 'sdk/ui', 'rpc', 'logger'],
  function(CONST, __w, Runtime, XDM, UI, RPC, Logger) {

    XDM.apply(RPC.jsonRpcConfig, {
      remote: {
        api: {}
      },
      local: {
        postLoginInfo: function(dialog_id, message) {
          var dialog = UI.getDialog(dialog_id);
          var msg;

          if (dialog) {
            msg = JSON.parse(message);
            dialog.call(msg);
          }

          UI.destroy(dialog_id);
        },

        setSize: function(dialog_id, w, h) {
          dialog = UI.getDialog(dialog_id);
          dialog.resize(w, h);
        }
      }
    }, true);

    var API = {
      getXdHandler: function() {
        return RPC.xdHandler();
      },

      api: function(path, method, params, cb) {
        url = CONST.root_url + '/api/v1/json' + (path.match(/^\//) ? path : '/' + path);
        var access_token = Runtime.getOAuthToken();
        if (access_token) {
          Logger.addCall();
          if (path == 'user_data/submit') {
            Logger.setSaveSize(params.value);
          }

          API.getXdHandler().api({method: method, url: url, data: (params || {}), headers: {'Authorization': 'Bearer ' + access_token}}, __w(cb), __w(cb));
        } else {
          __w(cb).call({}, null);
        }
      },

      apiOpen: function(path, method, params, cb) { // same as api but doesn't require login
        Logger.addCall();
        url = CONST.root_url + '/api/v1/json' + (path.match(/^\//) ? path : '/' + path);
        API.getXdHandler().api({method: method, url: url, data: (params || {})}, __w(cb), __w(cb));
      }
    }

    return API;
});

